/**
 *  Date    : 2020/03/19
 *  Author  : lbb1811
 *  Declare : Modal
 */
import React from 'react';

import { NOOP } from '@/constants/common';

import './Modal.scss';

export default function Modal(props) {

  const { children, className, showModal, onCloseModal, clickMaskClose, modalStyle = {}} = props;

  // 关闭弹框
  function closeModal(e) {
    e.stopPropagation();
    if(!clickMaskClose) return;
    onCloseModal();
  }

  return (
    <div className={`ModalContent ${showModal ? 'active' : ''}`} onTouchMove={e => e.stopPropagation()}>
      <div className="custom-modal" onClick={closeModal} style={modalStyle}>
        <div className={`modal-container ${className}`} onClick={e => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </div>
  );
}

Modal.defaultProps = {
  className: 'default-modal',
  showModal: false,  // 是否展示弹框
  clickMaskClose: true, // 点击浮层自动关闭
  onCloseModal: NOOP // 关闭的回调
};
